module.exports = __webpack_public_path__ + "img/scb.e0532921.jpeg";